import workFrontApi from '@/api/work-front.api'

export const workFrontService = (function () {
  'use strict'

  /**
   * Devuelve los datos de las frente de trabajos
   */
  async function getAll() {
    try {
      const response = await workFrontApi.getAll()
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  /**
   * Devuelve los datos para la tabla del ABM de Grupos
   * @param {*} pageSize
   * @param {*} pageNumber
   * @param {*} headers
   * @param {*} enterpriseIds
   */
  async function findAll(pageSize, pageNumber, headers = false, enterpriseIds) {
    try {
      /*
      if (pageSize > 0 && pageNumber > 0) {
        const response = await workFrontApi.findAll(pageSize, pageNumber, headers, enterpriseIds)
        return response.data
      } else {
        return {
          data: [],
          headers: []
        }
      }
      */
      const response = await workFrontApi.findAll(undefined, undefined, headers, enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return {
        data: [],
        headers: []
      }
    }
  }

  /**
   * Devuelve el total de frente de trabajos de la collection para el paginador de la tabla del ABM
   */
  async function getTotal(enterpriseIds) {
    try {
      const response = await workFrontApi.getTotal(enterpriseIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return 0
    }
  }

  /**
   * Devuelve un frente de trabajo con el id enviado como parámetro
   * @param {*} workFrontId
   */
  async function getWorkFront(workFrontId) {
    try {
        const response = await workFrontApi.getWorkFront(workFrontId)
        return response.data
    } catch (exception) {
        console.log(exception)
        return false
    }
  }

  /**
   * Devuelve los frente de trabajos con el id de empresa enviado como parámetro
   * @param {*} enterpriseId 
   */
  async function getWorkFrontsByEnterpriseId(enterpriseId) {
    try {
      const response = await workFrontApi.getWorkFrontsByEnterpriseId(enterpriseId)
      return response.data
    } catch (exception) {
      console.error(exception)
      return false
    }
  }

  /**
   * Para validar el nombre
   * Devuelve true si ya está asignado a un frente de trabajo
   * @param {*} name
   */
  async function validateWorkFrontName(name, enterpriseId) {
    try {
      if (name) {
        const response = await workFrontApi.validateWorkFrontName(name, enterpriseId)
        return response.data
      } else {
        return false
      }
    } catch (exception) {
      console.log(exception)
      return false
    }
  }

  /**
   * Para eliminar un workFront
   */
  async function deleteOne(id) {
    /*
    try {
        const response = await workFrontApi.deleteOne(id)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await workFrontApi.deleteOne(id)
    return response.data
  }

  /**
   * Para eliminación múltiple
   */
  async function deleteMany(ids) {
    /*
    try {
        const response = await workFrontApi.deleteMany(ids)
        return response.data
    } catch (exception) {
        console.log(exception)
        return null
    }
    */
    const response = await workFrontApi.deleteMany(ids)
    return response.data
  }


  /**
   * Crea una nuevo frente de trabajo en la collection
   * @param {*} workFront
   * @param {*} thingIds
   */
  async function create(workFront, thingIds) {
    /*
    try {
      const response = await workFrontApi.create(workFront, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await workFrontApi.create(workFront, thingIds)
    return response.data
  }

  /**
   *  Actualiza un frente de trabajo existente en la collection
   * @param {*} workFront
   * @param {*} thingIds
   */
  async function update(workFront, thingIds) {
    /*
    try {
      const response = await workFrontApi.update(workFront, thingIds)
      return response.data
    } catch (exception) {
      console.log(exception)
      return null
    }
    */
    const response = await workFrontApi.update(workFront, thingIds)
    return response.data
  }

  async function getStoreroomByWorkfrontId(enterpriseId, workFrontId) {
    const response = await workFrontApi.getStoreroomByWorkfrontId(enterpriseId, workFrontId);
    return response.data
  }

  return {
    findAll,
    getTotal,
    getWorkFront,
    validateWorkFrontName,
    deleteOne,
    deleteMany,
    create,
    update,
    getWorkFrontsByEnterpriseId,
    getAll,
    getStoreroomByWorkfrontId
  }
})()
